export default __webpack_public_path__ + "media/images/logo/yt-a5e601f8d2e0b2b7ec33955c32c884a7.svg";